import { Stack } from "@mui/material";

import { Button } from "../../../../components/Button";
import { DialogFooter } from "../../../../components/DialogFooter";

interface CancelShiftFooterProps {
  onKeepShift: () => void;
  onPressAndHoldToCancel: () => void;
  isLoading?: boolean;
}

export function CancelShiftFooter(props: CancelShiftFooterProps): JSX.Element {
  const { onKeepShift, onPressAndHoldToCancel, isLoading = false } = props;

  return (
    <DialogFooter orientation="vertical" sx={{ marginTop: "auto" }}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isLoading}
          sx={(theme) => ({
            color: theme.palette.error.main,
            borderColor: theme.palette.border?.primary,
          })}
          onClick={onPressAndHoldToCancel}
        >
          Press and hold to cancel
        </Button>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isLoading}
          sx={(theme) => ({
            color: theme.palette.text.primary,
            borderColor: theme.palette.border?.primary,
          })}
          onClick={onKeepShift}
        >
          Keep my shift
        </Button>
      </Stack>
    </DialogFooter>
  );
}
